import { render, staticRenderFns } from "./ModLeads.vue?vue&type=template&id=68655568&"
import script from "./ModLeads.vue?vue&type=script&lang=js&"
export * from "./ModLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports